import { HttpClient, JSON_STRING, createHttpGetOptions } from "../../../services/http/http-client";
import { ACCOUNTING_URL, BOOKING_URL } from "../../../services/common-urls";

export const ReportService = {
  findReportData: () => HttpClient.get(ACCOUNTING_URL, {
    section: 'reports',
    output: JSON_STRING
  }),
  exportBooking: ({
    payment_start_date = '',
    booking_start_date = '',
    invoice_start_date = '',
    payment_end_date = '',
    booking_end_date = '',
    invoice_end_date = '',
    invoice_project_id,
    invoiceline = undefined,
    report_type = undefined,
    mini_report = undefined,
  }) => HttpClient.getFinalURL(ACCOUNTING_URL, {
    section: 'reports',
    action: 'export_invoices',
    payment_start_date,
    booking_start_date,
    invoice_start_date,
    payment_end_date,
    booking_end_date,
    invoice_end_date,
    invoice_project_id,
    invoiceline,
    report_type,
    mini_report,
  }, createHttpGetOptions({
    qsStringifyArrayFormat: 'repeat',
    noJsonOutput: true
  })),
  exportBookingReport: ({
    action = 'finance_report',
    start_date = 0,
    end_date = 0,
    booking_status_id = 0,
    city = 0,
    country = 0,
    booking_location_id = 0,
    contact_id_promoter = 0,
    user_id = 0,
    artist_id = undefined
  }) => HttpClient.getFinalURL(BOOKING_URL, {
    section: 'reports',
    action,
    start_date,
    end_date,
    booking_status_id,
    city,
    country,
    booking_location_id,
    contact_id_promoter,
    user_id,
    artist_id,
  }, createHttpGetOptions({
    qsStringifyArrayFormat: 'repeat'
  })),
  // exportBookingFinanceReport: ({
  //   action = 'finance_report',
  //   start_date = 0,
  //   end_date = 0,
  //   booking_status_id = 0,
  //   city = 0,
  //   country = 0,
  //   booking_location_id = 0,
  //   contact_id_promoter = 0,
  //   user_id = 0,
  //   artist_id = undefined
  // }) => HttpClient.getFinalURL(BOOKING_URL, {
  //   section: 'reports',
  //   action,
  //   start_date,
  //   end_date,
  //   booking_status_id,
  //   city,
  //   country,
  //   booking_location_id,
  //   contact_id_promoter,
  //   user_id,
  //   artist_id,
  // }, createHttpGetOptions({
  //   qsStringifyArrayFormat: true,
  //   noJsonOutput: true
  // })),
  // exportBookingMoneyDetailsReport: ({
  //   action = 'money_details_report',
  //   start_date = 0,
  //   end_date = 0,
  //   booking_status_id = 0,
  //   city = 0,
  //   country = 0,
  //   booking_location_id = 0,
  //   contact_id_promoter = 0,
  //   user_id = 0,
  //   artist_id = undefined
  // }) => HttpClient.getFinalURL(BOOKING_URL, {
  //   section: 'reports',
  //   action,
  //   start_date,
  //   end_date,
  //   booking_status_id,
  //   city,
  //   country,
  //   booking_location_id,
  //   contact_id_promoter,
  //   user_id,
  //   artist_id,
  // }, createHttpGetOptions({
  //   qsStringifyArrayFormat: true,
  //   noJsonOutput: true
  // })),
  // exportBookingManagementReport: ({
  //   action = 'management_report',
  //   start_date = 0,
  //   end_date = 0,
  //   booking_status_id = 0,
  //   city = 0,
  //   country = 0,
  //   booking_location_id = 0,
  //   contact_id_promoter = 0,
  //   user_id = 0,
  //   artist_id = undefined
  // }) => HttpClient.getFinalURL(BOOKING_URL, {
  //   section: 'reports',
  //   action,
  //   start_date,
  //   end_date,
  //   booking_status_id,
  //   city,
  //   country,
  //   booking_location_id,
  //   contact_id_promoter,
  //   user_id,
  //   artist_id,
  // }, createHttpGetOptions({
  //   qsStringifyArrayFormat: true,
  //   noJsonOutput: true
  // })),
  // exportBookingExtendedFinanceReport: ({
  //   action = 'extended_finance_report',
  //   start_date = 0,
  //   end_date = 0,
  //   booking_status_id = 0,
  //   city = 0,
  //   country = 0,
  //   booking_location_id = 0,
  //   contact_id_promoter = 0,
  //   user_id = 0,
  //   artist_id = undefined
  // }) => HttpClient.getFinalURL(BOOKING_URL, {
  //   section: 'reports',
  //   action,
  //   start_date,
  //   end_date,
  //   booking_status_id,
  //   city,
  //   country,
  //   booking_location_id,
  //   contact_id_promoter,
  //   user_id,
  //   artist_id,
  // }, createHttpGetOptions({
  //   qsStringifyArrayFormat: true,
  //   noJsonOutput: true
  // })),
  findLocation: ({
    url = 'booking.pl',
    section = 'reports',
    action = 'search_location',
    table_id = 'br_location_table',
    status_id = '_',
    minSearchLength = '3',
    search
  }) => HttpClient.post(BOOKING_URL, {
    url,
    section,
    action,
    table_id,
    status_id,
    minSearchLength,
    search,
    output: JSON_STRING,
  }),
  findPromoter: ({
    url = 'booking.pl',
    section = 'reports',
    action = 'search_promoter',
    table_id = 'br_promoter_table',
    status_id = '_',
    minSearchLength = 3,
    search
  }) => HttpClient.post(BOOKING_URL, {
    url,
    section,
    action,
    table_id,
    status_id,
    minSearchLength,
    search,
    output: JSON_STRING,
  }),
  findCountryByCity: ({
    city
  }) => HttpClient.post(BOOKING_URL, {
    section: 'bookings',
    action: 'countries_of_city',
    city
  })
}

//#region Invoice Report Downloads
// https://dev.berlin3.com/berlin3/accounting.pl?section=reports 
//  action=export_invoices 
//  payment_start_date= 
//  booking_start_date= 
//  invoice_start_date=2015-08-11 
//  payment_end_date= 
//  booking_end_date= 
//  invoice_end_date=2019-08-16 
//  invoice_project_id=71 
//  invoice_project_id=67 
//  invoice_project_id=79 
//  invoice_project_id=72 
//  invoice_project_id=65

// https://dev.berlin3.com/berlin3/accounting.pl?
// section=reports 
// action=export_invoices 
// payment_start_date= 
// booking_start_date=2019-08-06 
// invoice_start_date=  
// payment_end_date=  
// booking_end_date=2019-08-16  
// invoice_end_date=  
// invoice_project_id=71  
// invoice_project_id=67


// https://dev.berlin3.com/berlin3/accounting.pl?section=reports 
//  action=export_invoices 
//  payment_start_date= 
//  booking_start_date=2015-08-11 
//  invoice_start_date= 
//  payment_end_date= 
//  booking_end_date=2019-08-16 
//  invoice_end_date= 
//  invoice_project_id=71 
//  invoice_project_id=67 
//  invoice_project_id=79 
//  invoice_project_id=72 
//  invoice_project_id=65


//  https://dev.berlin3.com/berlin3/accounting.pl?section=reports 
//  action=export_invoices 
//  payment_start_date= 
//  booking_start_date=2015-08-11 
//  invoice_start_date= 
//  payment_end_date= 
//  booking_end_date=2019-08-16 
//  invoice_end_date= 
//  invoice_project_id=71 
//  invoice_project_id=67 
//  invoice_project_id=79 
//  invoice_project_id=72 
//  invoice_project_id=65 
//  invoiceline=1


// https://dev.berlin3.com/berlin3/accounting.pl?section=reports 
//  action=export_invoices 
//  payment_start_date= 
//  booking_start_date=2015-08-11 
//  invoice_start_date= 
//  payment_end_date= 
//  booking_end_date=2019-08-16 
//  invoice_end_date= 
//  invoice_project_id=71 
//  invoice_project_id=67 
//  invoice_project_id=79 
//  invoice_project_id=72 
//  invoice_project_id=65 
//  report_type=new


// https://dev.berlin3.com/berlin3/accounting.pl?section=reports 
//  action=export_invoices 
//  payment_start_date= 
//  booking_start_date=2015-08-11 
//  invoice_start_date= 
//  payment_end_date= 
//  booking_end_date=2019-08-16 
//  invoice_end_date= 
//  invoice_project_id=71 
//  invoice_project_id=67 
//  invoice_project_id=79 
//  invoice_project_id=72 
//  invoice_project_id=65 
//  mini_report=invoice


// https://dev.berlin3.com/berlin3/accounting.pl?section=reports 
//  action=export_invoices 
//  payment_start_date= 
//  booking_start_date=2015-08-11 
//  invoice_start_date= 
//  payment_end_date= 
//  booking_end_date=2019-08-16 
//  invoice_end_date= 
//  invoice_project_id=71 
//  invoice_project_id=67 
//  invoice_project_id=79 
//  invoice_project_id=72 
//  invoice_project_id=65 
//  mini_report=cost


// https://dev.berlin3.com/berlin3/accounting.pl?
// section=reports 
//  action=export_invoices 
//  payment_start_date= 
//  booking_start_date=2015-08-11 
//  invoice_start_date= 
//  payment_end_date= 
//  booking_end_date=2019-08-16 
//  invoice_end_date= 
//  invoice_project_id=71 
//  invoice_project_id=67 
//  invoice_project_id=79 
//  invoice_project_id=72 
//  invoice_project_id=65 
//  mini_report=invioce_xmltemplate
//#endregion

//#region Booking Reports


// https://dev.berlin3.com/berlin3/booking.pl?section=reports
// action=finance_report
// start_date=2018-08-20
// end_date=2019-08-24
// artist_id=210
// artist_id=87
// booking_status_id=54
// city=Berlin
// country=Germany
// booking_location_id=0
// contact_id_promoter=0
// user_id=115


// https://dev.berlin3.com/berlin3/booking.pl?section=reports
// action=money_details_report
// start_date=2018-08-20
// end_date=2019-08-24
// artist_id=210
// artist_id=87
// booking_status_id=54
// city=Berlin
// country=Germany
// booking_location_id=0
// contact_id_promoter=0
// user_id=115

// https://dev.berlin3.com/berlin3/booking.pl?section=reports
// action=extended_finance_report
// start_date=2019-07-08
// end_date=2019-08-18
// artist_id=0
// booking_status_id=48
// city=Berlin
// country=Germany
// booking_location_id=0
// contact_id_promoter=0
// user_id=98

// https://dev.berlin3.com/berlin3/booking.pl?section=reports
// action=finance_report
// start_date=2019-08-05
// end_date=2019-08-14
// artist_id=203
// artist_id=121
// booking_status_id=0
// city=Dhaka
// country=Bangladesh
// booking_location_id=0
// contact_id_promoter=0
// user_id=0

// https://dev.berlin3.com/berlin3/booking.pl?section=reports
// action=finance_report
// start_date=2019-08-05
// end_date=2019-08-14
// artist_id=203
// artist_id=121
// booking_status_id=0
// city=0
// country=0
// booking_location_id=0
// contact_id_promoter=0
// user_id=0


// https://dev.berlin3.com/berlin3/booking.pl?section=reports
// action=finance_report
// start_date=2019-08-05
// end_date=0
// artist_id=203
// artist_id=121
// booking_status_id=0
// city=0
// country=0
// booking_location_id=0
// contact_id_promoter=0
// user_id=0

// https://dev.berlin3.com/berlin3/booking.pl?section=reports
// action=finance_report
// start_date=2019-08-05
// end_date=0
// artist_id=0
// booking_status_id=0
// city=0
// country=0
// booking_location_id=0
// contact_id_promoter=0
// user_id=0

// https://dev.berlin3.com/berlin3/booking.pl?section=reports
// action=finance_report
// start_date=0
// end_date=0
// artist_id=121
// artist_id=130
// booking_status_id=0
// city=0
// country=0
// booking_location_id=0
// contact_id_promoter=0
// user_id=0

// https://dev.berlin3.com/berlin3/accounting.pl?section=reports
// action=finance_report
// start_date=0
// end_date=0
// booking_status_id=0
// city=0
// country=0
// booking_location_id=0
// contact_id_promoter=0
// user_id=0
// artist_id=121
// artist_id=130

//#endregion

// https://dev.berlin3.com/berlin3/booking.pl?section=reports
// action=management_report
// start_date=0
// end_date=0
// artist_id=121
// artist_id=130
// booking_status_id=0
// city=Berlin
// country=Germany
// booking_location_id=0
// contact_id_promoter=0
// user_id=0
